var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomInPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3868 2C5.76246 2 2 5.76246 2 10.3868C2 15.0112 5.76246 18.7736 10.3868 18.7736C12.4674 18.7736 14.3693 18.0079 15.8363 16.7485L20.8981 21.8103C21.0188 21.9317 21.183 22 21.3542 22C21.5254 22 21.6896 21.9317 21.8103 21.8103C21.9314 21.6894 21.9995 21.5253 21.9995 21.3542C21.9995 21.1831 21.9314 21.019 21.8103 20.8981L16.7485 15.8363C18.0554 14.3215 18.7741 12.3874 18.7736 10.3868C18.7736 5.76246 15.0112 2 10.3868 2ZM3.29028 10.3868C3.29028 6.47404 6.47404 3.29028 10.3868 3.29028C14.2996 3.29028 17.4834 6.47404 17.4834 10.3868C17.4834 14.2996 14.2996 17.4834 10.3868 17.4834C6.47404 17.4834 3.29028 14.2996 3.29028 10.3868ZM12.9674 9.74168H11.032V7.80626C11.032 7.44996 10.7431 7.16112 10.3868 7.16112C10.0305 7.16112 9.74168 7.44996 9.74168 7.80626V9.74168H7.80626C7.44996 9.74168 7.16112 10.0305 7.16112 10.3868C7.16112 10.7431 7.44996 11.032 7.80626 11.032H9.74168V12.9674C9.74168 13.3237 10.0305 13.6125 10.3868 13.6125C10.7431 13.6125 11.032 13.3237 11.032 12.9674V11.032H12.9674C13.3237 11.032 13.6125 10.7431 13.6125 10.3868C13.6125 10.0305 13.3237 9.74168 12.9674 9.74168Z",
    fill: "#767B88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomInPdf);
export default __webpack_public_path__ + "static/media/zoom-in-pdf.b7a94544cba1d0f5c4a01d05b00d1835.svg";
export { ForwardRef as ReactComponent };